module.exports = __webpack_public_path__ + "img/reaction_neutral.d308a47.svg";